import { FormFields } from '@App/forms/v2/common/form-field'
import { FormFieldTypes } from '@App/enum/form-field-types'
import populateSchema from '@App/forms/v2/helpers/populate-schema'
import {
    address2Key,
    address2Label,
    address3Key,
    address3Label,
    address4Key,
    address4Label,
    addressFormKey,
    attentionKey,
    attentionLabel,
    cityKey,
    cityLabel,
    countryKey,
    countryLabel,
    extendedAddressFormKey,
    postalCodeKey,
    postalCodeLabel,
    stateKey,
    stateLabel,
    streetAddressKey,
    streetAddressLabel,
    unitNumberKey,
    unitNumberLabel,
} from '@Entities/schemas/common/address-schema-keys'

type AnyAddressType = any

export const createUserAddressFormFields = (parentObjectName: string, zodObject: any): FormFields<AnyAddressType> => {
    const fieldsNoSchema: FormFields<AnyAddressType> = {
        [streetAddressKey]: {
            name: streetAddressKey,
            parentObjectName,
            label: streetAddressLabel,
            type: FormFieldTypes.TEXT,
        },
        [unitNumberKey]: { name: unitNumberKey, parentObjectName, label: unitNumberLabel, type: FormFieldTypes.TEXT },
        [cityKey]: { name: cityKey, label: cityLabel, parentObjectName, type: FormFieldTypes.TEXT },
        [countryKey]: {
            name: countryKey,
            parentObjectName,
            label: countryLabel,
            type: FormFieldTypes.DROPDOWN,
            options: [],
        },
        [stateKey]: { name: stateKey, label: stateLabel, parentObjectName, type: FormFieldTypes.TEXT },
        [postalCodeKey]: { name: postalCodeKey, parentObjectName, label: postalCodeLabel, type: FormFieldTypes.TEXT },
    }
    return populateSchema(fieldsNoSchema, zodObject)
}

export const createAddressFormFields = (parentObjectName: string, zodObject: any): FormFields<AnyAddressType> => {
    const fieldsNoSchema: FormFields<AnyAddressType> = {
        [streetAddressKey]: {
            name: streetAddressKey,
            parentObjectName,
            label: streetAddressLabel,
            type: FormFieldTypes.TEXT,
        },
        [unitNumberKey]: { name: unitNumberKey, parentObjectName, label: unitNumberLabel, type: FormFieldTypes.TEXT },
        [attentionKey]: { name: attentionKey, parentObjectName, label: attentionLabel, type: FormFieldTypes.TEXT },
        [cityKey]: { name: cityKey, label: cityLabel, parentObjectName, type: FormFieldTypes.TEXT },
        [countryKey]: {
            name: countryKey,
            parentObjectName,
            label: countryLabel,
            type: FormFieldTypes.DROPDOWN,
            options: [],
        },
        [stateKey]: { name: stateKey, label: stateLabel, parentObjectName, type: FormFieldTypes.TEXT },
        [postalCodeKey]: { name: postalCodeKey, parentObjectName, label: postalCodeLabel, type: FormFieldTypes.TEXT },
    }
    return populateSchema(fieldsNoSchema, zodObject)
}

export const createExtendedAddressFormFields = (zodObject: any): FormFields<AnyAddressType> => {
    const fieldsNoSchema: FormFields<AnyAddressType> = {
        [cityKey]: {
            name: cityKey,
            label: cityLabel,
            parentObjectName: extendedAddressFormKey,
            type: FormFieldTypes.TEXT,
        },
        [countryKey]: {
            name: countryKey,
            parentObjectName: extendedAddressFormKey,
            label: countryLabel,
            type: FormFieldTypes.DROPDOWN,
            options: [],
        },
        [stateKey]: {
            name: stateKey,
            label: stateLabel,
            parentObjectName: extendedAddressFormKey,
            type: FormFieldTypes.TEXT,
        },
        [postalCodeKey]: {
            name: postalCodeKey,
            parentObjectName: extendedAddressFormKey,
            label: postalCodeLabel,
            type: FormFieldTypes.TEXT,
        },
        [address2Key]: {
            name: address2Key,
            parentObjectName: extendedAddressFormKey,
            label: address2Label,
            type: FormFieldTypes.TEXT,
        },
        [address3Key]: {
            name: address3Key,
            parentObjectName: extendedAddressFormKey,
            label: address3Label,
            type: FormFieldTypes.TEXT,
        },
        [address4Key]: {
            name: address4Key,
            parentObjectName: extendedAddressFormKey,
            label: address4Label,
            type: FormFieldTypes.TEXT,
        },
    }
    return populateSchema(fieldsNoSchema, zodObject)
}

export const buildAddressFormFields = (addressSchema: any, userAddressSchema: any, extendedAddressSchema: any) => {
    const userAddressFormFields = createUserAddressFormFields(addressFormKey, userAddressSchema)
    const addressFormFields = createAddressFormFields(addressFormKey, addressSchema)
    const extendedAddressFormFields = createExtendedAddressFormFields(extendedAddressSchema)
    return { userAddressFormFields, addressFormFields, extendedAddressFormFields }
}
